import { Styles } from 'react-select'
import { presets, colors } from 'assets'
import { CSSProperties } from 'react'
import { applyStyle } from 'components/common'

export const selectStyles: Partial<Styles> = {
  container: applyStyle({
    height: 'fit-content',
    textTransform: 'none',
    textAlign: 'left'
  }),
  control: applyStyle(state => ({
    // border: 0,
    border: `1px solid ${colors.buttonGrey} !important`,
    boxShadow: state.isFocused ? presets.boxShadow : 'unset',
    height: 35,
    '& > svg': { marginLeft: 10 }
  })),
  valueContainer: applyStyle({
    padding: '5px 10px',
    fontSize: 12,
    lineHeight: '15px'
  }),
  multiValue: applyStyle({
    backgroundColor: colors.backgroundLight,
    height: 22,
    maxWidth: 90,
    borderRadius: 22,
    padding: '0 5px'
  }),
  multiValueLabel: applyStyle({
    color: colors.black,
    textTransform: 'none',
    fontSize: 10,
    margin: 'auto'
  }),
  indicatorSeparator: applyStyle({
    display: 'none'
  }),
  multiValueRemove: applyStyle({
    ':hover': { backgroundColor: 'unset' }
  } as CSSProperties),
  option: applyStyle({
    fontSize: 12,
    lineHeight: '15px'

    // '&:hover': {
    //   backgroundColor: colors.grey
    // },
    // ':active': {
    //   backgroundColor: colors.grey
    // }
  } as CSSProperties)

  // multiValueRemove
}
